import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import * as moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotifierService } from 'angular-notifier';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ReservationsService } from 'src/app/services/reservations.service';

@Component({
  selector: 'app-greet-request-dialog',
  templateUrl: './greet-request-dialog.component.html',
  styleUrls: ['./greet-request-dialog.component.scss']
})
export class GreetRequestDialogComponent implements OnInit {

  @Input() greetInfo: any
  reason = '';
  public event: EventEmitter<any> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef,
    private spinner: NgxSpinnerService,
    private reservationsService: ReservationsService,
    private notifier: NotifierService) {
  }

  ngOnInit() {
  }

  getFormatedDate(date) {
    return moment.utc(date).format('MMM DD, YYYY HH:mm')
  }

  greetReject(){
    if (this.reason == '') {
      this.notifier.notify('warning', 'Please enter reason')
      return
    }
    this.spinner.show();
        console.log(this.greetInfo)
        this.greetInfo.reason = this.reason;
        //adminRejectGreetRequest
        this.reservationsService.updateGreetRequest(this.greetInfo).subscribe(res => {
          if (res['status']) {
            this.notifier.notify('success', 'Successfully Rejected');
            setTimeout(() => {
              this.spinner.hide();
              this.triggerEvent(true)
              this.bsModalRef.hide();
          }, 1000);
          }else{
            setTimeout(() => {
              this.spinner.hide();
              this.triggerEvent(true)
              this.bsModalRef.hide();
          }, 1000);
          }

        });
  }
  triggerEvent(item) {
    this.event.emit({ data: item, res: 200 });
  }

}
